// utils.ts

/**
 * Handles input changes with snap points for numeric controls
 */
export const handleInputChangeWithSnap = (
  setter: React.Dispatch<React.SetStateAction<number>>,
  value: number,
  max: number,
  type: string,
  snapPoints: number[] = [],
  snapThreshold: number = 5
) => {
  const maxValue = type === 'latitude' ? 90 :
                  type === 'longitude' ? 180 :
                  max;
  let numValue = Math.min(Math.max(-maxValue, value), maxValue);

  // Check if the value is within snapping distance of a snap point
  snapPoints.forEach((point) => {
    if (Math.abs(numValue - point) <= snapThreshold) {
      numValue = point;
    }
  });

  setter(numValue);
};

/**
 * Formats filename for exports based on original filename and export type
 * Handles special cases for sphere exports and half projections
 */
export const formatExportFilename = (
  originalFilename: string,
  projectionType: string,
  format: string,
  isHalf: boolean = false
): string => {
  // Get first 21 chars of filename without extension
  const baseFilename = originalFilename.split('.')[0];
  const truncatedBase = baseFilename.slice(0, 21);

  // Handle projection name formatting
  const projectionCode = projectionType.toUpperCase() === 'EQUIRECTANGULAR' 
    ? 'EQUI' 
    : projectionType.toUpperCase();

  // Handle sphere exports - all types use just SPHERE
  if (projectionCode === 'SPHERE') {
    return `${truncatedBase}_SPHERE.${format.toLowerCase()}`;
  }

  // Add _half suffix for half exports
  const halfSuffix = isHalf ? '_half' : '';
  
  return `${truncatedBase}_${projectionCode}${halfSuffix}.${format.toLowerCase()}`;
};

// Example filename formats:
// Regular projection: "image_EQUI.png"
// Half projection: "image_EQUI_half.png"
// Sphere exports: "image_SPHERE.webm" or "image_SPHERE.png"